"use client";

import { useEffect, useRef } from "react";
import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

export function AmplitudeProvider() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    amplitude.add(sessionReplayPlugin({ sampleRate: 0.1 }));
    amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY ?? "8511df41a34a85ab697d54b751ed53b3", {
      autocapture: true,
    });
  }, []);

  return null;
}
